import { render, staticRenderFns } from "./Designer.vue?vue&type=template&id=3b12b794"
import script from "./Designer.vue?vue&type=script&lang=js"
export * from "./Designer.vue?vue&type=script&lang=js"
import style0 from "./Designer.vue?vue&type=style&index=0&id=3b12b794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports